module.exports = __webpack_public_path__ + "img/client-3.3baee32b.jpg";